/**
 * Created by vladislav on 22.03.2021
 */

var SlotMachineReel = function () {
    cleverapps.EventEmitter.call(this);

    this.symbols = SlotMachineReel.SYMBOLS.map(function (symbol, index) {
        return new SlotMachineSymbol(this, symbol, index);
    }, this);
    this.current = 0;

    this.setCurrentByType(PseudoRandom.GET().choose(SlotMachineReel.SYMBOLS).type);
};

SlotMachineReel.prototype = Object.create(cleverapps.EventEmitter.prototype);
SlotMachineReel.prototype.constructor = SlotMachineReel;

SlotMachineReel.prototype.setCurrentByType = function (type) {
    this.current = this.symbols.filter(function (symbol) {
        return symbol.type === type;
    })[0].index;

    for (var i = 0; i < this.symbols.length; i++) {
        this.symbols[i].move();
    }
};

SlotMachineReel.prototype.getCurrent = function () {
    return this.symbols[this.current];
};

SlotMachineReel.prototype.spin = function (type, callback) {
    this.getCurrent().reset();

    this.minSpinsAmount = PseudoRandom.GET().random(20, 25);
    this._spinOneDegree(0, type, callback);
};

SlotMachineReel.prototype._spinOneDegree = function (spins, type, callback) {
    spins++;
    this.current = (this.current - 1 + this.symbols.length) % this.symbols.length;

    var isLast = spins >= this.minSpinsAmount && this.symbols[this.current].type === type;

    for (var i = 0; i < this.symbols.length; i++) {
        this.symbols[i].spin(isLast);
    }

    setTimeout(function () {
        if (isLast) {
            callback();
        } else {
            this._spinOneDegree(spins, type, callback);
        }
    }.bind(this), SlotMachineReel.ONE_DEGREE_DURATION);
};

SlotMachineReel.ONE_DEGREE_DURATION = 50;

SlotMachineReel.SYMBOLS = [
    SlotMachine.BOOSTER_1_SYMBOL,
    SlotMachine.COIN_SYMBOL,
    SlotMachine.BOOSTER_2_SYMBOL,
    SlotMachine.BOOSTER_1_SYMBOL,
    SlotMachine.BOOSTER_3_SYMBOL,
    SlotMachine.BOOSTER_1_SYMBOL,
    SlotMachine.COINS_SYMBOL,
    SlotMachine.BOOSTER_2_SYMBOL
];